import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DomainService } from '../../shared/services';

@Component({
    selector: 'app-domain',
    templateUrl: './domain.component.html',
    styleUrls: ['./domain.component.scss']
})
export class DomainComponent implements OnInit {

    message: String = '';
    constructor(
        private router: Router,
        private domainService: DomainService
    ) {
    }

    ngOnInit() {
        if (this.domainService.isDomainVerified()) {
            this.router.navigate(['/login']);
        }
        else {
            this.message = 'Verifying your domain';
            this.domainService.verify().subscribe(resp => {
                if (resp.error) {
                    this.message = resp.error.message;
                    this.domainService.deleteDomainVerified();
                }
                else {
                    // check for maintenance mode
                    if (resp.data.active) {
                        this.message = 'Your domain is verified.';
                        this.domainService.saveDomainVerified();
                        if (resp.data.frontendDomainSettings) {
                            this.domainService.saveFrontendSettings(resp.data.frontendDomainSettings.data);
                        }
                        this.router.navigate(['/login']);
                    }
                    else {
                        this.message = 'Maintenance Mode.';
                        this.domainService.deleteDomainVerified();
                    }
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/routes/domain/domain.component.ts